"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6350],{

/***/ 83234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J1": function() { return /* binding */ FormErrorMessage; },
/* harmony export */   "Kn": function() { return /* binding */ useFormControlProps; },
/* harmony export */   "NI": function() { return /* binding */ FormControl; },
/* harmony export */   "Yp": function() { return /* binding */ useFormControl; },
/* harmony export */   "lX": function() { return /* binding */ FormLabel; }
/* harmony export */ });
/* unused harmony exports FormErrorIcon, FormHelperText, RequiredIndicator, useFormControlContext, useFormControlStyles, useFormErrorStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28387);
/* harmony import */ var _chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76734);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54520);
/* harmony import */ var _chakra_ui_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52494);
// ../../../react-shim.js


// src/form-control.tsx




// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;
var ariaAttr = (condition) => condition ? true : void 0;
function callAllHandlers(...fns) {
  return function func(event) {
    fns.some((fn) => {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}

// src/form-control.tsx

var [FormControlStylesProvider, useFormControlStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `FormControlStylesContext`,
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
});
var [FormControlProvider, useFormControlContext] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  strict: false,
  name: "FormControlContext"
});
function useFormControlProvider(props) {
  const {
    id: idProp,
    isRequired,
    isInvalid,
    isDisabled,
    isReadOnly,
    ...htmlProps
  } = props;
  const uuid = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
  const id = idProp || `field-${uuid}`;
  const labelId = `${id}-label`;
  const feedbackId = `${id}-feedback`;
  const helpTextId = `${id}-helptext`;
  const [hasFeedbackText, setHasFeedbackText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [hasHelpText, setHasHelpText] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [isFocused, setFocus] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const getHelpTextProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    id: helpTextId,
    ...props2,
    ref: (0,_chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_2__/* .mergeRefs */ .lq)(forwardedRef, (node) => {
      if (!node)
        return;
      setHasHelpText(true);
    })
  }), [helpTextId]);
  const getLabelProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    ...props2,
    ref: forwardedRef,
    "data-focus": dataAttr(isFocused),
    "data-disabled": dataAttr(isDisabled),
    "data-invalid": dataAttr(isInvalid),
    "data-readonly": dataAttr(isReadOnly),
    id: props2.id ?? labelId,
    htmlFor: props2.htmlFor ?? id
  }), [id, isDisabled, isFocused, isInvalid, isReadOnly, labelId]);
  const getErrorMessageProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    id: feedbackId,
    ...props2,
    ref: (0,_chakra_ui_react_use_merge_refs__WEBPACK_IMPORTED_MODULE_2__/* .mergeRefs */ .lq)(forwardedRef, (node) => {
      if (!node)
        return;
      setHasFeedbackText(true);
    }),
    "aria-live": "polite"
  }), [feedbackId]);
  const getRootProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    ...props2,
    ...htmlProps,
    ref: forwardedRef,
    role: "group"
  }), [htmlProps]);
  const getRequiredIndicatorProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((props2 = {}, forwardedRef = null) => ({
    ...props2,
    ref: forwardedRef,
    role: "presentation",
    "aria-hidden": true,
    children: props2.children || "*"
  }), []);
  return {
    isRequired: !!isRequired,
    isInvalid: !!isInvalid,
    isReadOnly: !!isReadOnly,
    isDisabled: !!isDisabled,
    isFocused: !!isFocused,
    onFocus: () => setFocus(true),
    onBlur: () => setFocus(false),
    hasFeedbackText,
    setHasFeedbackText,
    hasHelpText,
    setHasHelpText,
    id,
    labelId,
    feedbackId,
    helpTextId,
    htmlProps,
    getHelpTextProps,
    getErrorMessageProps,
    getRootProps,
    getLabelProps,
    getRequiredIndicatorProps
  };
}
var FormControl = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)(function FormControl2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useMultiStyleConfig */ .jC)("Form", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);
  const {
    getRootProps,
    htmlProps: _,
    ...context
  } = useFormControlProvider(ownProps);
  const className = cx("chakra-form-control", props.className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormControlProvider, {
    value: context
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormControlStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.div */ .m$.div, {
    ...getRootProps({}, ref),
    className,
    __css: styles["container"]
  })));
});
FormControl.displayName = "FormControl";
var FormHelperText = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)(function FormHelperText2(props, ref) {
  const field = useFormControlContext();
  const styles = useFormControlStyles();
  const className = cx("chakra-form__helper-text", props.className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.div */ .m$.div, {
    ...field == null ? void 0 : field.getHelpTextProps(props, ref),
    __css: styles.helperText,
    className
  });
});
FormHelperText.displayName = "FormHelperText";

// src/use-form-control.ts
function useFormControl(props) {
  const { isDisabled, isInvalid, isReadOnly, isRequired, ...rest } = useFormControlProps(props);
  return {
    ...rest,
    disabled: isDisabled,
    readOnly: isReadOnly,
    required: isRequired,
    "aria-invalid": ariaAttr(isInvalid),
    "aria-required": ariaAttr(isRequired),
    "aria-readonly": ariaAttr(isReadOnly)
  };
}
function useFormControlProps(props) {
  const field = useFormControlContext();
  const {
    id,
    disabled,
    readOnly,
    required,
    isRequired,
    isInvalid,
    isReadOnly,
    isDisabled,
    onFocus,
    onBlur,
    ...rest
  } = props;
  const labelIds = props["aria-describedby"] ? [props["aria-describedby"]] : [];
  if ((field == null ? void 0 : field.hasFeedbackText) && (field == null ? void 0 : field.isInvalid)) {
    labelIds.push(field.feedbackId);
  }
  if (field == null ? void 0 : field.hasHelpText) {
    labelIds.push(field.helpTextId);
  }
  return {
    ...rest,
    "aria-describedby": labelIds.join(" ") || void 0,
    id: id ?? (field == null ? void 0 : field.id),
    isDisabled: disabled ?? isDisabled ?? (field == null ? void 0 : field.isDisabled),
    isReadOnly: readOnly ?? isReadOnly ?? (field == null ? void 0 : field.isReadOnly),
    isRequired: required ?? isRequired ?? (field == null ? void 0 : field.isRequired),
    isInvalid: isInvalid ?? (field == null ? void 0 : field.isInvalid),
    onFocus: callAllHandlers(field == null ? void 0 : field.onFocus, onFocus),
    onBlur: callAllHandlers(field == null ? void 0 : field.onBlur, onBlur)
  };
}

// src/form-error.tsx



var [FormErrorStylesProvider, useFormErrorStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `FormErrorStylesContext`,
  errorMessage: `useFormErrorStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormError />" `
});
var FormErrorMessage = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useMultiStyleConfig */ .jC)("FormError", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(props);
  const field = useFormControlContext();
  if (!(field == null ? void 0 : field.isInvalid))
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(FormErrorStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.div */ .m$.div, {
    ...field == null ? void 0 : field.getErrorMessageProps(ownProps, ref),
    className: cx("chakra-form__error-message", props.className),
    __css: {
      display: "flex",
      alignItems: "center",
      ...styles.text
    }
  }));
});
FormErrorMessage.displayName = "FormErrorMessage";
var FormErrorIcon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = useFormErrorStyles();
  const field = useFormControlContext();
  if (!(field == null ? void 0 : field.isInvalid))
    return null;
  const _className = cx("chakra-form__error-icon", props.className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
    ref,
    "aria-hidden": true,
    ...props,
    __css: styles.icon,
    className: _className
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "currentColor",
    d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
  }));
});
FormErrorIcon.displayName = "FormErrorIcon";

// src/form-label.tsx

var FormLabel = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)(function FormLabel2(passedProps, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .useStyleConfig */ .mq)("FormLabel", passedProps);
  const props = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_4__/* .omitThemingProps */ .Lr)(passedProps);
  const {
    className,
    children,
    requiredIndicator = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RequiredIndicator, null),
    optionalIndicator = null,
    ...rest
  } = props;
  const field = useFormControlContext();
  const ownProps = (field == null ? void 0 : field.getLabelProps(rest, ref)) ?? { ref, ...rest };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.label */ .m$.label, {
    ...ownProps,
    className: cx("chakra-form__label", props.className),
    __css: {
      display: "block",
      textAlign: "start",
      ...styles
    }
  }, children, (field == null ? void 0 : field.isRequired) ? requiredIndicator : optionalIndicator);
});
FormLabel.displayName = "FormLabel";
var RequiredIndicator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .forwardRef */ .Gp)(function RequiredIndicator2(props, ref) {
  const field = useFormControlContext();
  const styles = useFormControlStyles();
  if (!(field == null ? void 0 : field.isRequired))
    return null;
  const className = cx("chakra-form__required-indicator", props.className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .chakra.span */ .m$.span, {
    ...field == null ? void 0 : field.getRequiredIndicatorProps(props, ref),
    __css: styles.requiredIndicator,
    className
  });
});
RequiredIndicator.displayName = "RequiredIndicator";



/***/ }),

/***/ 20979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ InputGroup; },
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "Ui": function() { return /* binding */ InputLeftAddon; },
/* harmony export */   "xH": function() { return /* binding */ InputRightElement; },
/* harmony export */   "xW": function() { return /* binding */ InputRightAddon; }
/* harmony export */ });
/* unused harmony exports InputAddon, InputLeftElement, useInputGroupStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83234);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83904);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54520);
/* harmony import */ var _chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95336);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28387);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34031);
/* harmony import */ var _chakra_ui_object_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46076);
// ../../../react-shim.js


// src/input.tsx



var Input = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function Input2(props, ref) {
  const { htmlSize, ...rest } = props;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Input", rest);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(rest);
  const input = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__/* .useFormControl */ .Yp)(ownProps);
  const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-input", props.className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.input */ .m$.input, {
    size: htmlSize,
    ...input,
    __css: styles.field,
    ref,
    className: _className
  });
});
Input.displayName = "Input";
Input.id = "Input";

// src/input-addon.tsx



// src/input-group.tsx






var [InputGroupStylesProvider, useInputGroupStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_5__/* .createContext */ .k)({
  name: `InputGroupStylesContext`,
  errorMessage: `useInputGroupStyles returned is 'undefined'. Seems you forgot to wrap the components in "<InputGroup />" `
});
var InputGroup = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function InputGroup2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Input", props);
  const { children, className, ...rest } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-input__group", className);
  const groupStyles = {};
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_6__/* .getValidChildren */ .W)(children);
  const input = styles.field;
  validChildren.forEach((child) => {
    if (!styles)
      return;
    if (input && child.type.id === "InputLeftElement") {
      groupStyles.paddingStart = input.height ?? input.h;
    }
    if (input && child.type.id === "InputRightElement") {
      groupStyles.paddingEnd = input.height ?? input.h;
    }
    if (child.type.id === "InputRightAddon") {
      groupStyles.borderEndRadius = 0;
    }
    if (child.type.id === "InputLeftAddon") {
      groupStyles.borderStartRadius = 0;
    }
  });
  const clones = validChildren.map((child) => {
    var _a, _b;
    const theming = (0,_chakra_ui_object_utils__WEBPACK_IMPORTED_MODULE_7__/* .compact */ .oA)({
      size: ((_a = child.props) == null ? void 0 : _a.size) || props.size,
      variant: ((_b = child.props) == null ? void 0 : _b.variant) || props.variant
    });
    return child.type.id !== "Input" ? (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, theming) : (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, Object.assign(theming, groupStyles, child.props));
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m$.div, {
    className: _className,
    ref,
    __css: {
      width: "100%",
      display: "flex",
      position: "relative"
    },
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputGroupStylesProvider, {
    value: styles
  }, clones));
});
InputGroup.displayName = "InputGroup";

// src/input-addon.tsx
var placements = {
  left: {
    marginEnd: "-1px",
    borderEndRadius: 0,
    borderEndColor: "transparent"
  },
  right: {
    marginStart: "-1px",
    borderStartRadius: 0,
    borderStartColor: "transparent"
  }
};
var StyledAddon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    flex: "0 0 auto",
    width: "auto",
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap"
  }
});
var InputAddon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function InputAddon2(props, ref) {
  const { placement = "left", ...rest } = props;
  const placementStyles = placements[placement] ?? {};
  const styles = useInputGroupStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledAddon, {
    ref,
    ...rest,
    __css: {
      ...styles.addon,
      ...placementStyles
    }
  });
});
InputAddon.displayName = "InputAddon";
var InputLeftAddon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function InputLeftAddon2(props, ref) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputAddon, {
    ref,
    placement: "left",
    ...props,
    className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-input__left-addon", props.className)
  });
});
InputLeftAddon.displayName = "InputLeftAddon";
InputLeftAddon.id = "InputLeftAddon";
var InputRightAddon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function InputRightAddon2(props, ref) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputAddon, {
    ref,
    placement: "right",
    ...props,
    className: (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-input__right-addon", props.className)
  });
});
InputRightAddon.displayName = "InputRightAddon";
InputRightAddon.id = "InputRightAddon";

// src/input-element.tsx


var StyledInputElement = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    zIndex: 2
  }
});
var InputElement = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function InputElement2(props, ref) {
  const { placement = "left", ...rest } = props;
  const styles = useInputGroupStyles();
  const input = styles.field;
  const attr = placement === "left" ? "insetStart" : "insetEnd";
  const elementStyles = {
    [attr]: "0",
    width: (input == null ? void 0 : input.height) ?? (input == null ? void 0 : input.h),
    height: (input == null ? void 0 : input.height) ?? (input == null ? void 0 : input.h),
    fontSize: input == null ? void 0 : input.fontSize,
    ...styles.element
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInputElement, {
    ref,
    __css: elementStyles,
    ...rest
  });
});
InputElement.id = "InputElement";
InputElement.displayName = "InputElement";
var InputLeftElement = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function InputLeftElement2(props, ref) {
  const { className, ...rest } = props;
  const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-input__left-element", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputElement, {
    ref,
    placement: "left",
    className: _className,
    ...rest
  });
});
InputLeftElement.id = "InputLeftElement";
InputLeftElement.displayName = "InputLeftElement";
var InputRightElement = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function InputRightElement2(props, ref) {
  const { className, ...rest } = props;
  const _className = (0,_chakra_ui_shared_utils__WEBPACK_IMPORTED_MODULE_4__.cx)("chakra-input__right-element", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InputElement, {
    ref,
    placement: "right",
    className: _className,
    ...rest
  });
});
InputRightElement.id = "InputRightElement";
InputRightElement.displayName = "InputRightElement";



/***/ }),

/***/ 71197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mi": function() { return /* binding */ Slide; },
/* harmony export */   "Qh": function() { return /* binding */ scaleFadeConfig; },
/* harmony export */   "UO": function() { return /* binding */ Collapse; },
/* harmony export */   "Xc": function() { return /* binding */ slideFadeConfig; },
/* harmony export */   "uf": function() { return /* binding */ fadeConfig; }
/* harmony export */ });
/* unused harmony exports EASINGS, Fade, ScaleFade, SlideFade, getSlideTransition, withDelay */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84441);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9882);
// ../../../react-shim.js


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
function isDev() {
  return "production" !== "production";
}
var warn = (options) => {
  const { condition, message } = options;
  if (condition && isDev()) {
    console.warn(message);
  }
};

// src/collapse.tsx



// src/transition-utils.ts
var TRANSITION_EASINGS = {
  ease: [0.25, 0.1, 0.25, 1],
  easeIn: [0.4, 0, 1, 1],
  easeOut: [0, 0, 0.2, 1],
  easeInOut: [0.4, 0, 0.2, 1]
};
var TRANSITION_VARIANTS = {
  scale: {
    enter: { scale: 1 },
    exit: { scale: 0.95 }
  },
  fade: {
    enter: { opacity: 1 },
    exit: { opacity: 0 }
  },
  pushLeft: {
    enter: { x: "100%" },
    exit: { x: "-30%" }
  },
  pushRight: {
    enter: { x: "-100%" },
    exit: { x: "30%" }
  },
  pushUp: {
    enter: { y: "100%" },
    exit: { y: "-30%" }
  },
  pushDown: {
    enter: { y: "-100%" },
    exit: { y: "30%" }
  },
  slideLeft: {
    position: { left: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "-100%", y: 0 }
  },
  slideRight: {
    position: { right: 0, top: 0, bottom: 0, width: "100%" },
    enter: { x: 0, y: 0 },
    exit: { x: "100%", y: 0 }
  },
  slideUp: {
    position: { top: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "-100%" }
  },
  slideDown: {
    position: { bottom: 0, left: 0, right: 0, maxWidth: "100vw" },
    enter: { x: 0, y: 0 },
    exit: { x: 0, y: "100%" }
  }
};
function getSlideTransition(options) {
  const side = (options == null ? void 0 : options.direction) ?? "right";
  switch (side) {
    case "right":
      return TRANSITION_VARIANTS.slideRight;
    case "left":
      return TRANSITION_VARIANTS.slideLeft;
    case "bottom":
      return TRANSITION_VARIANTS.slideDown;
    case "top":
      return TRANSITION_VARIANTS.slideUp;
    default:
      return TRANSITION_VARIANTS.slideRight;
  }
}
var TRANSITION_DEFAULTS = {
  enter: {
    duration: 0.2,
    ease: TRANSITION_EASINGS.easeOut
  },
  exit: {
    duration: 0.1,
    ease: TRANSITION_EASINGS.easeIn
  }
};
var withDelay = {
  enter: (transition, delay) => ({
    ...transition,
    delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["enter"]
  }),
  exit: (transition, delay) => ({
    ...transition,
    delay: typeof delay === "number" ? delay : delay == null ? void 0 : delay["exit"]
  })
};

// src/collapse.tsx
var isNumeric = (value) => value != null && parseInt(value.toString(), 10) > 0;
var defaultTransitions = {
  exit: {
    height: { duration: 0.2, ease: TRANSITION_EASINGS.ease },
    opacity: { duration: 0.3, ease: TRANSITION_EASINGS.ease }
  },
  enter: {
    height: { duration: 0.3, ease: TRANSITION_EASINGS.ease },
    opacity: { duration: 0.4, ease: TRANSITION_EASINGS.ease }
  }
};
var variants = {
  exit: ({
    animateOpacity,
    startingHeight,
    transition,
    transitionEnd,
    delay
  }) => ({
    ...animateOpacity && { opacity: isNumeric(startingHeight) ? 1 : 0 },
    height: startingHeight,
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit,
    transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(defaultTransitions.exit, delay)
  }),
  enter: ({
    animateOpacity,
    endingHeight,
    transition,
    transitionEnd,
    delay
  }) => ({
    ...animateOpacity && { opacity: 1 },
    height: endingHeight,
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter,
    transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(defaultTransitions.enter, delay)
  })
};
var Collapse = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref) => {
  const {
    in: isOpen,
    unmountOnExit,
    animateOpacity = true,
    startingHeight = 0,
    endingHeight = "auto",
    style,
    className,
    transition,
    transitionEnd,
    ...rest
  } = props;
  const [mounted, setMounted] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    const timeout = setTimeout(() => {
      setMounted(true);
    });
    return () => clearTimeout(timeout);
  }, []);
  warn({
    condition: Boolean(startingHeight > 0 && unmountOnExit),
    message: `startingHeight and unmountOnExit are mutually exclusive. You can't use them together`
  });
  const hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
  const custom = {
    startingHeight,
    endingHeight,
    animateOpacity,
    transition: !mounted ? { enter: { duration: 0 } } : transition,
    transitionEnd: {
      enter: transitionEnd == null ? void 0 : transitionEnd.enter,
      exit: unmountOnExit ? transitionEnd == null ? void 0 : transitionEnd.exit : {
        ...transitionEnd == null ? void 0 : transitionEnd.exit,
        display: hasStartingHeight ? "block" : "none"
      }
    }
  };
  const show = unmountOnExit ? isOpen : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    initial: false,
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ref,
    ...rest,
    className: cx("chakra-collapse", className),
    style: {
      overflow: "hidden",
      display: "block",
      ...style
    },
    custom,
    variants,
    initial: unmountOnExit ? "exit" : false,
    animate,
    exit: "exit"
  }));
});
Collapse.displayName = "Collapse";

// src/fade.tsx


var variants2 = {
  enter: ({ transition, transitionEnd, delay } = {}) => ({
    opacity: 1,
    transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
  }),
  exit: ({ transition, transitionEnd, delay } = {}) => ({
    opacity: 0,
    transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
  })
};
var fadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants2
};
var Fade = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function Fade2(props, ref) {
  const {
    unmountOnExit,
    in: isOpen,
    className,
    transition,
    transitionEnd,
    delay,
    ...rest
  } = props;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const custom = { transition, transitionEnd, delay };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ref,
    className: cx("chakra-fade", className),
    custom,
    ...fadeConfig,
    animate,
    ...rest
  }));
});
Fade.displayName = "Fade";

// src/scale-fade.tsx


var variants3 = {
  exit: ({ reverse, initialScale, transition, transitionEnd, delay }) => ({
    opacity: 0,
    ...reverse ? { scale: initialScale, transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit } : { transitionEnd: { scale: initialScale, ...transitionEnd == null ? void 0 : transitionEnd.exit } },
    transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(TRANSITION_DEFAULTS.exit, delay)
  }),
  enter: ({ transitionEnd, transition, delay }) => ({
    opacity: 1,
    scale: 1,
    transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
  })
};
var scaleFadeConfig = {
  initial: "exit",
  animate: "enter",
  exit: "exit",
  variants: variants3
};
var ScaleFade = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function ScaleFade2(props, ref) {
  const {
    unmountOnExit,
    in: isOpen,
    reverse = true,
    initialScale = 0.95,
    className,
    transition,
    transitionEnd,
    delay,
    ...rest
  } = props;
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const custom = { initialScale, reverse, transition, transitionEnd, delay };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ref,
    className: cx("chakra-offset-slide", className),
    ...scaleFadeConfig,
    animate,
    custom,
    ...rest
  }));
});
ScaleFade.displayName = "ScaleFade";

// src/slide.tsx


var defaultTransition = {
  exit: {
    duration: 0.15,
    ease: TRANSITION_EASINGS.easeInOut
  },
  enter: {
    type: "spring",
    damping: 25,
    stiffness: 180
  }
};
var variants4 = {
  exit: ({ direction, transition, transitionEnd, delay }) => {
    const { exit: exitStyles } = getSlideTransition({ direction });
    return {
      ...exitStyles,
      transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(defaultTransition.exit, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
    };
  },
  enter: ({ direction, transitionEnd, transition, delay }) => {
    const { enter: enterStyles } = getSlideTransition({ direction });
    return {
      ...enterStyles,
      transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(defaultTransition.enter, delay),
      transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
    };
  }
};
var Slide = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function Slide2(props, ref) {
  const {
    direction = "right",
    style,
    unmountOnExit,
    in: isOpen,
    className,
    transition,
    transitionEnd,
    delay,
    motionProps,
    ...rest
  } = props;
  const transitionStyles = getSlideTransition({ direction });
  const computedStyle = Object.assign({ position: "fixed" }, transitionStyles.position, style);
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const custom = { transitionEnd, transition, direction, delay };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ...rest,
    ref,
    initial: "exit",
    className: cx("chakra-slide", className),
    animate,
    exit: "exit",
    custom,
    variants: variants4,
    style: computedStyle,
    ...motionProps
  }));
});
Slide.displayName = "Slide";

// src/slide-fade.tsx


var variants5 = {
  initial: ({ offsetX, offsetY, transition, transitionEnd, delay }) => ({
    opacity: 0,
    x: offsetX,
    y: offsetY,
    transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit
  }),
  enter: ({ transition, transitionEnd, delay }) => ({
    opacity: 1,
    x: 0,
    y: 0,
    transition: (transition == null ? void 0 : transition.enter) ?? withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
    transitionEnd: transitionEnd == null ? void 0 : transitionEnd.enter
  }),
  exit: ({ offsetY, offsetX, transition, transitionEnd, reverse, delay }) => {
    const offset = { x: offsetX, y: offsetY };
    return {
      opacity: 0,
      transition: (transition == null ? void 0 : transition.exit) ?? withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      ...reverse ? { ...offset, transitionEnd: transitionEnd == null ? void 0 : transitionEnd.exit } : { transitionEnd: { ...offset, ...transitionEnd == null ? void 0 : transitionEnd.exit } }
    };
  }
};
var slideFadeConfig = {
  initial: "initial",
  animate: "enter",
  exit: "exit",
  variants: variants5
};
var SlideFade = (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function SlideFade2(props, ref) {
  const {
    unmountOnExit,
    in: isOpen,
    reverse = true,
    className,
    offsetX = 0,
    offsetY = 8,
    transition,
    transitionEnd,
    delay,
    ...rest
  } = props;
  const show = unmountOnExit ? isOpen && unmountOnExit : true;
  const animate = isOpen || unmountOnExit ? "enter" : "exit";
  const custom = {
    offsetX,
    offsetY,
    reverse,
    transition,
    transitionEnd,
    delay
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePresence */ .M, {
    custom
  }, show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .E.div, {
    ref,
    className: cx("chakra-offset-slide", className),
    custom,
    ...slideFadeConfig,
    animate,
    ...rest
  }));
});
SlideFade.displayName = "SlideFade";



/***/ }),

/***/ 59891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Qc": function() { return /* binding */ AutoComplete; },
  "Vp": function() { return /* binding */ AutoCompleteInput; },
  "Gb": function() { return /* binding */ AutoCompleteItem; },
  "Jm": function() { return /* binding */ AutoCompleteList; }
});

// UNUSED EXPORTS: AutoCompleteCreatable, AutoCompleteGroup, AutoCompleteGroupTitle, AutoCompleteProvider, AutoCompleteTag, baseItemStyles, useAutoComplete, useAutoCompleteContext

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react-utils/dist/index.esm.js
var index_esm = __webpack_require__(10187);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js
var system_dist_index_esm = __webpack_require__(83904);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/popover/dist/index.esm.js + 7 modules
var popover_dist_index_esm = __webpack_require__(81521);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/utils/dist/index.esm.js
var utils_dist_index_esm = __webpack_require__(92127);
;// CONCATENATED MODULE: ./node_modules/react-nanny/lib/es6/_private/utils.js


var processTypes = function (types) { return types.map(function (x) {
    switch (typeof x) {
        case 'string':
            return x;
        case 'function':
            return typeOfComponent(React.createElement(x));
        case 'object':
        default: {
            var component = React.createElement(x);
            var type = typeOfComponent(component);
            if (type === 'react.forward_ref') {
                return typeOfComponent(component.type.render(component.props, component.ref));
            }
            return typeOfComponent(x);
        }
    }
}); };
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var utils_toChildrenArray = function (children) { return Array.isArray(children) ? children : react.Children.toArray(children); };

;// CONCATENATED MODULE: ./node_modules/react-nanny/lib/es6/getChildren/index.js
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};

/**
 * Gets all children by specified predicate
 *
 * @since v1.0.0
 * @template T
 * @template TC - Type of child
 * @param {T} children - JSX children
 * @param {(child: TC) => boolean} predicate - The predicate to determine if the given child is a match
 * @returns {TC[]} - All matching children
 * @example
 * // Finds all children that have an 'active' prop set to true
 * getChildren(children, child => child.props.active);
 */
var getChildren = function (children, predicate) {
    return toChildrenArray(children).filter(predicate);
};
/**
 * Gets all children by specified predicate (deep search)
 *
 * @since v1.0.0
 * @template T
 * @template TC - Type of child
 * @param {T} children - JSX children
 * @param {(child: TC) => boolean} predicate - The predicate to determine if the given child is a match
 * @returns {TC[]} - All matching children
 * @example
 * // Finds the first occurrence of a child that has a prop of 'active' set to true
 * getChildrenDeep(children, child => child.props.active);
 */
var getChildrenDeep = function (children, predicate) {
    var _a;
    var _children = utils_toChildrenArray(children);
    var output = [];
    for (var _i = 0, _children_1 = _children; _i < _children_1.length; _i++) {
        var child = _children_1[_i];
        if (predicate(child)) {
            output = __spreadArray(__spreadArray([], output), [child]);
        }
        if ((_a = child.props) === null || _a === void 0 ? void 0 : _a.children) {
            output = __spreadArray(__spreadArray([], output), getChildrenDeep(child.props.children, predicate));
        }
    }
    return output;
};

;// CONCATENATED MODULE: ./node_modules/react-nanny/lib/es6/getChild/index.js

/**
 * Gets first child by specified predicate
 *
 * @since v1.0.0
 * @template T
 * @template TC - Type of child
 * @param {T} children - JSX children
 * @param {(child: TChild) => boolean} predicate - The predicate to determine if the given child is a match
 * @returns {TChild} - The first matching child
 * @example
 * // Finds the first occurrence of a child that has a prop of 'active' set to true
 * getChild(children, child => child.props.active);
 */
var getChild = function (children, predicate) {
    return toChildrenArray(children).find(predicate);
};
/**
 * Gets first child by specified predicate (deep search)
 *
 * @since v1.0.0
 * @template T
 * @template TC - Type of child
 * @param {T} children - JSX children
 * @param {(child: TC) => boolean} predicate - The predicate to determine if the given child is a match
 * @returns {TChild} - The first matching child
 * @example
 * // Finds the first occurrence of a child that has a prop of 'active' set to true
 * getChildDeep(children, child => child.props.active);
 */
var getChildDeep = function (children, predicate) {
    var _a;
    var _children = utils_toChildrenArray(children);
    for (var _i = 0, _children_1 = _children; _i < _children_1.length; _i++) {
        var child = _children_1[_i];
        if (predicate(child))
            return child;
        if ((_a = child.props) === null || _a === void 0 ? void 0 : _a.children) {
            var result = getChildDeep(child.props.children, predicate);
            if (result)
                return result;
        }
    }
    return;
};

;// CONCATENATED MODULE: ./node_modules/@choc-ui/chakra-autocomplete/dist/chakra-autocomplete.esm.js








var _createContext = /*#__PURE__*/(0,index_esm/* createContext */.kr)({
  name: "AutoCompleteContext",
  errorMessage: "useAutoCompleteContext: `context` is undefined. Seems you forgot to wrap all autoomplete components within `<AutoComplete />`"
}),
    AutoCompleteProvider = _createContext[0],
    useAutoCompleteContext = _createContext[1];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/*
 * @param str1 The first string to compare.
 * @param str2 The second string to compare.
 * @param gramSize The size of the grams. Defaults to length 2.
 */
function fuzzyScore(str1, str2, gramSize) {
  if (gramSize === void 0) {
    gramSize = 2;
  }

  function getNGrams(s, len) {
    s = " ".repeat(len - 1) + s.toLowerCase() + " ".repeat(len - 1);
    var v = new Array(s.length - len + 1);

    for (var i = 0; i < v.length; i++) {
      v[i] = s.slice(i, i + len);
    }

    return v;
  }

  if (!(str1 != null && str1.length) || !(str2 != null && str2.length)) {
    return 0.0;
  } //Order the strings by length so the order they're passed in doesn't matter
  //and so the smaller string's ngrams are always the ones in the set


  var s1 = str1.length < str2.length ? str1 : str2;
  var s2 = str1.length < str2.length ? str2 : str1;
  var pairs1 = getNGrams(s1, gramSize);
  var pairs2 = getNGrams(s2, gramSize);
  var set = new Set(pairs1);
  var total = pairs2.length;
  var hits = 0;

  for (var _iterator = _createForOfIteratorHelperLoose(pairs2), _step; !(_step = _iterator()).done;) {
    var item = _step.value;

    if (set["delete"](item)) {
      hits++;
    }
  }

  return hits / total;
}

var getDefItemValue = function getDefItemValue(item) {
  var _ref;

  return (_ref = typeof item === "string" ? item : item[Object.keys(item)[0]]) == null ? void 0 : _ref.toString();
};
var setEmphasis = function setEmphasis(children, query) {
  if (typeof children !== "string" || (0,utils_dist_index_esm/* isEmpty */.xb)(query)) {
    return children;
  }

  var newChildren = children.toString().replace(new RegExp(escapeRegex(query), "gi"), function (match) {
    return "<mark>" + match + "</mark>";
  });
  return newChildren;
};
var getItemList = function getItemList(children) {
  var itemChildren = getChildrenDeep(children, function (child) {
    var _child$type;

    return (child == null ? void 0 : (_child$type = child.type) == null ? void 0 : _child$type.displayName) === "AutoCompleteItem";
  });
  return itemChildren.map(function (item) {
    var itemObj = (0,utils_dist_index_esm/* pick */.ei)(item.props, ["value", "label", "fixed", "disabled"]);
    var _item$props$getValue = item.props.getValue,
        getValue = _item$props$getValue === void 0 ? getDefItemValue : _item$props$getValue;
    var value = getValue(itemObj.value);
    var finObj = (0,utils_dist_index_esm/* isDefined */.$K)(itemObj.label) ? itemObj : _extends({}, itemObj, {
      label: value
    });
    return _extends({}, finObj, {
      value: value,
      originalValue: itemObj.value
    });
  });
};
var getFocusedStyles = function getFocusedStyles() {
  return {
    bg: "whiteAlpha.100",
    _light: {
      bg: "gray.200"
    }
  };
};
var defaultFilterMethod = function defaultFilterMethod(query, itemValue, itemLabel) {
  return (itemValue == null ? void 0 : itemValue.toLowerCase().indexOf(query == null ? void 0 : query.toLowerCase())) >= 0 || (itemLabel == null ? void 0 : itemLabel.toLowerCase().indexOf(query == null ? void 0 : query.toLowerCase())) >= 0 || fuzzyScore(query, itemValue) >= 0.5 || fuzzyScore(query, itemLabel) >= 0.5;
};

function escapeRegex(string) {
  return string.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}

var getMultipleWrapStyles = function getMultipleWrapStyles(themeInput, multiple) {
  return _extends({}, multiple && _extends({}, themeInput.field, {
    _focusWithin: themeInput.field._focus,
    pos: "relative",
    minH: 9,
    // px: 3,
    py: 1.5,
    spacing: 3
  }), {
    cursor: "text",
    h: "fit-content"
  });
};

var hasFirstItem = function hasFirstItem(children, firstItem) {
  var result = getChildDeep(children, function (child) {
    var _child$type;

    return (child == null ? void 0 : (_child$type = child.type) == null ? void 0 : _child$type.displayName) === "AutoCompleteItem" && child.props.value === (firstItem == null ? void 0 : firstItem.value);
  });
  return result;
};
var hasLastItem = function hasLastItem(children, lastItem) {
  var result = getChildDeep(children, function (child) {
    var _child$type2;

    return (child == null ? void 0 : (_child$type2 = child.type) == null ? void 0 : _child$type2.displayName) === "AutoCompleteItem" && child.props.value === (lastItem == null ? void 0 : lastItem.value);
  });
  return result;
};
var hasChildren = function hasChildren(children, filteredList) {
  return (0,utils_dist_index_esm/* isDefined */.$K)(getChildDeep(children, function (child) {
    var _child$props, _child$props2;

    var value = (0,utils_dist_index_esm/* runIfFn */.Pu)(((_child$props = child.props) == null ? void 0 : _child$props.getValue) || getDefItemValue, ((_child$props2 = child.props) == null ? void 0 : _child$props2.value) || {});
    return filteredList.some(function (i) {
      return i.value === value;
    });
  }));
};

var _excluded = ["onBlur", "onChange", "onFocus", "onKeyDown", "variant"],
    _excluded2 = ["_fixed", "_focus", "children", "disabled", "label", "value", "fixed", "getValue", "onClick", "onMouseOver", "sx"];
/**
 * useAutoComplete that provides all the state and focus management logic
 * for the autocomplete component. It is consumed by the `Autocomplete` component
 *
 */

function useAutoComplete(autoCompleteProps) {
  var _defaultQuery, _itemList$;

  var _autoCompleteProps$cl = autoCompleteProps.closeOnBlur,
      closeOnBlur = _autoCompleteProps$cl === void 0 ? true : _autoCompleteProps$cl,
      closeOnSelect = autoCompleteProps.closeOnSelect,
      creatable = autoCompleteProps.creatable,
      emphasize = autoCompleteProps.emphasize,
      _autoCompleteProps$em = autoCompleteProps.emptyState,
      emptyState = _autoCompleteProps$em === void 0 ? true : _autoCompleteProps$em,
      freeSolo = autoCompleteProps.freeSolo,
      isReadOnly = autoCompleteProps.isReadOnly,
      listAllValuesOnFocus = autoCompleteProps.listAllValuesOnFocus,
      maxSuggestions = autoCompleteProps.maxSuggestions,
      multiple = autoCompleteProps.multiple,
      defaultValue = autoCompleteProps.defaultValue,
      _autoCompleteProps$de = autoCompleteProps.defaultValues,
      defaultValues = _autoCompleteProps$de === void 0 ? defaultValue ? [defaultValue] : [] : _autoCompleteProps$de,
      onReady = autoCompleteProps.onReady,
      defaultIsOpen = autoCompleteProps.defaultIsOpen,
      disableFilter = autoCompleteProps.disableFilter,
      _autoCompleteProps$re = autoCompleteProps.restoreOnBlurIfEmpty,
      restoreOnBlurIfEmpty = _autoCompleteProps$re === void 0 ? !freeSolo : _autoCompleteProps$re,
      _autoCompleteProps$sh = autoCompleteProps.shouldRenderSuggestions,
      shouldRenderSuggestions = _autoCompleteProps$sh === void 0 ? function () {
    return true;
  } : _autoCompleteProps$sh,
      _autoCompleteProps$su = autoCompleteProps.submitKeys,
      submitKeys = _autoCompleteProps$su === void 0 ? [] : _autoCompleteProps$su,
      suggestWhenEmpty = autoCompleteProps.suggestWhenEmpty,
      value = autoCompleteProps.value,
      _autoCompleteProps$va = autoCompleteProps.values,
      valuesProp = _autoCompleteProps$va === void 0 ? value ? typeof value === "string" ? [value] : [].concat(value) : undefined : _autoCompleteProps$va;
  closeOnSelect = closeOnSelect ? closeOnSelect : multiple ? false : true;
  freeSolo = freeSolo ? freeSolo : multiple ? true : autoCompleteProps.freeSolo;

  var _useDisclosure = (0,dist_index_esm/* useDisclosure */.qY)({
    defaultIsOpen: defaultIsOpen
  }),
      isOpen = _useDisclosure.isOpen,
      onClose = _useDisclosure.onClose,
      onOpen = _useDisclosure.onOpen;

  var children = (0,utils_dist_index_esm/* runIfFn */.Pu)(autoCompleteProps.children, {
    isOpen: isOpen,
    onClose: onClose,
    onOpen: onOpen
  });
  var itemList = getItemList(children);
  var inputRef = (0,react.useRef)(null);
  var inputWrapperRef = (0,react.useRef)(null);
  var listRef = (0,react.useRef)(null);
  var interactionRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      listAll = _useState[0],
      setListAll = _useState[1];

  var defaultQuery = "";
  if (multiple) defaultQuery = "";else if (!(0,utils_dist_index_esm/* isUndefined */.o8)(defaultValues)) defaultQuery = defaultValues[0];else if (!(0,utils_dist_index_esm/* isUndefined */.o8)(valuesProp)) defaultQuery = valuesProp[0];

  var _useState2 = (0,react.useState)((_defaultQuery = defaultQuery) != null ? _defaultQuery : ""),
      query = _useState2[0],
      setQuery = _useState2[1];

  var filteredResults = disableFilter ? itemList : itemList.filter(function (i) {
    return i.fixed || (0,utils_dist_index_esm/* runIfFn */.Pu)(autoCompleteProps.filter || defaultFilterMethod, query, i.value, i.label) || listAll;
  }).filter(function (i, index) {
    return maxSuggestions ? i.fixed || index < maxSuggestions : true;
  }); // Add Creatable to Filtered List

  var creatableArr = creatable ? [{
    value: query,
    noFilter: true,
    creatable: true
  }] : [];
  var filteredList = [].concat(filteredResults, creatableArr);

  var _useControllableState = (0,dist_index_esm/* useControllableState */.Tx)({
    defaultValue: defaultValues,
    value: valuesProp,
    onChange: function onChange(newValues) {
      var item = filteredList.find(function (opt) {
        return opt.value === newValues[0];
      });
      var items = newValues.map(function (val) {
        return filteredList.find(function (opt) {
          return opt.value === val;
        });
      });
      (0,utils_dist_index_esm/* runIfFn */.Pu)(autoCompleteProps.onChange, multiple ? newValues : newValues[0], multiple ? items : item);
    }
  }),
      values = _useControllableState[0],
      setValues = _useControllableState[1];

  var _useState3 = (0,react.useState)((_itemList$ = itemList[0]) == null ? void 0 : _itemList$.value),
      focusedValue = _useState3[0],
      setFocusedValue = _useState3[1];

  var maxSelections = autoCompleteProps.maxSelections || values.length + 1;
  var focusedIndex = filteredList.findIndex(function (i) {
    return i.value === focusedValue;
  });
  var nextItem = (0,utils_dist_index_esm/* getNextItem */.vi)(focusedIndex, filteredList, !!autoCompleteProps.rollNavigation);
  var prevItem = (0,utils_dist_index_esm/* getPrevItem */.J4)(focusedIndex, filteredList, !!autoCompleteProps.rollNavigation);
  var firstItem = (0,utils_dist_index_esm/* getFirstItem */.l8)(filteredList);
  var lastItem = (0,utils_dist_index_esm/* getLastItem */.s)(filteredList);
  (0,dist_index_esm/* useUpdateEffect */.rf)(function () {
    setFocusedValue(firstItem == null ? void 0 : firstItem.value);
  }, [query]);
  (0,react.useEffect)(function () {
    var _itemList$2;

    if (!isOpen) setFocusedValue((_itemList$2 = itemList[0]) == null ? void 0 : _itemList$2.value);
  }, [isOpen]);
  (0,react.useEffect)(function () {
    var focusedItem = itemList.find(function (i) {
      return i.value === focusedValue;
    });
    (0,utils_dist_index_esm/* runIfFn */.Pu)(autoCompleteProps.onOptionFocus, {
      item: focusedItem,
      focusMethod: interactionRef.current,
      isNewInput: focusedItem == null ? void 0 : focusedItem.creatable
    });
  }, [focusedValue, autoCompleteProps.onOptionFocus]);

  var selectItem = function selectItem(optionValue) {
    var _inputRef$current2;

    if (!values.includes(optionValue) && values.length < maxSelections) {
      setValues(function (v) {
        return multiple ? [].concat(v, [optionValue]) : [optionValue];
      });
    }

    var option = filteredList.find(function (i) {
      return i.value === optionValue;
    });

    if (multiple) {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.focus();
    }

    if (autoCompleteProps.focusInputOnSelect) (_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.focus();
    (0,utils_dist_index_esm/* runIfFn */.Pu)(autoCompleteProps.onSelectOption, {
      item: option,
      selectMethod: interactionRef.current,
      isNewInput: option == null ? void 0 : option.creatable
    });

    if (option != null && option.creatable) {
      (0,utils_dist_index_esm/* runIfFn */.Pu)(autoCompleteProps.onCreateOption, {
        item: (0,utils_dist_index_esm/* omit */.CE)(option, ["noFilter"]),
        selectMethod: interactionRef.current
      });
    }

    var optionLabel = (option == null ? void 0 : option.label) || (option == null ? void 0 : option.value);
    setQuery(function () {
      return multiple ? "" : optionLabel != null ? optionLabel : "";
    });
    if (closeOnSelect) onClose();
  };

  var removeItem = function removeItem(itemValue, focusInput) {
    var _inputRef$current3;

    setValues(function (prevValues) {
      var item = itemList.find(function (opt) {
        return opt.value === itemValue;
      });
      (0,utils_dist_index_esm/* runIfFn */.Pu)(autoCompleteProps.onTagRemoved, itemValue, item, prevValues);
      return prevValues.filter(function (i) {
        return i !== itemValue;
      });
    });
    if (query === itemValue) setQuery("");
    if (focusInput) (_inputRef$current3 = inputRef.current) == null ? void 0 : _inputRef$current3.focus();
  };

  var resetItems = function resetItems(focusInput) {
    var _inputRef$current4;

    setValues([]);
    if (focusInput) (_inputRef$current4 = inputRef.current) == null ? void 0 : _inputRef$current4.focus();
  };

  var tags = multiple ? values.map(function (tag) {
    var _itemList$find;

    return {
      label: ((_itemList$find = itemList.find(function (item) {
        return item.value === tag;
      })) == null ? void 0 : _itemList$find.label) || tag,
      onRemove: function onRemove() {
        return removeItem(tag);
      }
    };
  }) : [];
  (0,react.useEffect)(function () {
    (0,utils_dist_index_esm/* runIfFn */.Pu)(onReady, {
      tags: tags
    });
  }, [values]);

  var getInputProps = function getInputProps(props, themeInput) {
    var _onBlur = props.onBlur,
        _onChange = props.onChange,
        _onFocus = props.onFocus,
        _onKeyDown = props.onKeyDown,
        variant = props.variant,
        rest = _objectWithoutPropertiesLoose(props, _excluded);

    return {
      wrapper: _extends({
        ref: inputWrapperRef,
        onClick: function onClick() {
          var _inputRef$current5;

          inputRef == null ? void 0 : (_inputRef$current5 = inputRef.current) == null ? void 0 : _inputRef$current5.focus();
        }
      }, getMultipleWrapStyles(themeInput, multiple), rest),
      input: _extends({
        isReadOnly: isReadOnly,
        onFocus: function onFocus(e) {
          (0,utils_dist_index_esm/* runIfFn */.Pu)(_onFocus, e);
          if (autoCompleteProps.openOnFocus && !isReadOnly) onOpen();
          if (autoCompleteProps.selectOnFocus) e.target.select();
          if (listAllValuesOnFocus) setListAll(true);
        },
        onBlur: function onBlur(e) {
          var _listRef$current, _inputWrapperRef$curr;

          (0,utils_dist_index_esm/* runIfFn */.Pu)(_onBlur, e);
          var listIsFocused = e.relatedTarget === (listRef == null ? void 0 : listRef.current) || ((_listRef$current = listRef.current) == null ? void 0 : _listRef$current.contains(e.relatedTarget));
          var inputWrapperIsFocused = (_inputWrapperRef$curr = inputWrapperRef.current) == null ? void 0 : _inputWrapperRef$curr.contains(e.relatedTarget);

          if (!listIsFocused && !inputWrapperIsFocused) {
            if (closeOnBlur) onClose();

            if (!values.includes(e.target.value) && restoreOnBlurIfEmpty) {
              var latestValue = (0,utils_dist_index_esm/* getLastItem */.s)(values);
              var latestValueItem = itemList.find(function (i) {
                return i.value === latestValue;
              });
              var latestValueLabel = (latestValueItem == null ? void 0 : latestValueItem.label) || (latestValueItem == null ? void 0 : latestValueItem.value) || "";
              setQuery(latestValueLabel);
            }
          }
        },
        onChange: function onChange(e) {
          var newValue = e.target.value;
          (0,utils_dist_index_esm/* runIfFn */.Pu)(_onChange, e);
          setQuery(newValue);
          var queryIsEmpty = (0,utils_dist_index_esm/* isEmpty */.xb)(newValue);
          if ((0,utils_dist_index_esm/* runIfFn */.Pu)(shouldRenderSuggestions, newValue) && (!queryIsEmpty || suggestWhenEmpty)) onOpen();else onClose();
          setListAll(false);
        },
        onKeyDown: function onKeyDown(e) {
          (0,utils_dist_index_esm/* runIfFn */.Pu)(_onKeyDown, e);
          interactionRef.current = "keyboard";
          var key = e.key;
          var focusedItem = filteredList[focusedIndex];

          if (["Enter"].concat(submitKeys).includes(key)) {
            var _inputRef$current6;

            if (focusedItem && !(focusedItem != null && focusedItem.disabled)) selectItem(focusedItem == null ? void 0 : focusedItem.value);else (_inputRef$current6 = inputRef.current) == null ? void 0 : _inputRef$current6.focus();
            e.preventDefault();
            return;
          }

          if (key === "ArrowDown") {
            setFocusedValue(nextItem == null ? void 0 : nextItem.value);
            e.preventDefault();
            return;
          }

          if (key === "ArrowUp") {
            setFocusedValue(prevItem == null ? void 0 : prevItem.value);
            e.preventDefault();
            return;
          }

          if (key === "Tab") {
            setFocusedValue(nextItem == null ? void 0 : nextItem.value);

            if (isOpen) {
              e.preventDefault();
            }

            return;
          }

          if (key === "Home") {
            setFocusedValue(firstItem == null ? void 0 : firstItem.value);
            e.preventDefault();
            return;
          }

          if (key === "End") {
            setFocusedValue(lastItem == null ? void 0 : lastItem.value);
            e.preventDefault();
            return;
          }

          if (key === "Escape") {
            (0,utils_dist_index_esm/* callAll */.PP)(onClose, e.preventDefault);
          }
        },
        value: query,
        variant: multiple ? "unstyled" : variant
      }, rest)
    };
  };

  var wrapperDim = (0,dist_index_esm/* useDimensions */.Di)(inputWrapperRef, true);
  var inputDim = (0,dist_index_esm/* useDimensions */.Di)(inputRef, true);

  var getListProps = function getListProps() {
    var width = autoCompleteProps.multiple ? wrapperDim == null ? void 0 : wrapperDim.marginBox.width : inputDim == null ? void 0 : inputDim.marginBox.width;
    return {
      width: width
    };
  };

  var getItemProps = function getItemProps(props, creatable) {
    var _getValue;

    var _fixed = props._fixed,
        _focus = props._focus,
        itemChild = props.children,
        disabled = props.disabled,
        label = props.label,
        valueProp = props.value,
        fixed = props.fixed,
        _props$getValue = props.getValue,
        getValue = _props$getValue === void 0 ? getDefItemValue : _props$getValue,
        _onClick = props.onClick,
        _onMouseOver = props.onMouseOver,
        sx = props.sx,
        rest = _objectWithoutPropertiesLoose(props, _excluded2);

    var value = creatable ? valueProp : (_getValue = getValue(valueProp)) == null ? void 0 : _getValue.toString();
    var isFocused = value === focusedValue;
    var isValidSuggestion = filteredList.findIndex(function (i) {
      return i.value === value;
    }) >= 0;
    var itemLabel = itemChild || label || value;
    return {
      item: _extends({}, typeof itemLabel !== "string" || !emphasize ? {
        children: itemLabel
      } : {
        dangerouslySetInnerHTML: {
          __html: setEmphasis(itemLabel, query)
        }
      }, {
        "aria-selected": values.includes(value),
        "aria-disabled": disabled,
        _disabled: {
          opacity: 0.4,
          cursor: "not-allowed",
          userSelect: "none"
        },
        onClick: function onClick(e) {
          var _inputRef$current7;

          (0,utils_dist_index_esm/* runIfFn */.Pu)(_onClick, e);
          if (!disabled) selectItem(value);else (_inputRef$current7 = inputRef.current) == null ? void 0 : _inputRef$current7.focus();
        },
        onMouseOver: function onMouseOver(e) {
          (0,utils_dist_index_esm/* runIfFn */.Pu)(_onMouseOver, e);
          setFocusedValue(value);
          interactionRef.current = "mouse";
        },
        sx: _extends({}, sx, {
          mark: _extends({
            color: "inherit",
            bg: "transparent"
          }, (0,utils_dist_index_esm/* isObject */.Kn)(emphasize) ? emphasize : {
            fontWeight: emphasize ? "extrabold" : "inherit"
          })
        })
      }, isFocused && (_focus || getFocusedStyles()), fixed && _fixed, rest),
      root: {
        isValidSuggestion: isValidSuggestion,
        value: value
      }
    };
  };

  var getGroupProps = function getGroupProps(props) {
    var hasItems = hasChildren(props.children, filteredList);
    return {
      divider: {
        hasFirstChild: hasFirstItem(props.children, firstItem),
        hasLastChild: hasLastItem(props.children, (0,utils_dist_index_esm/* getLastItem */.s)(filteredList.filter(function (i) {
          return (0,utils_dist_index_esm/* isUndefined */.o8)(i == null ? void 0 : i.noFilter);
        })))
      },
      group: {
        display: hasItems ? "initial" : "none"
      }
    };
  };

  var getEmptyStateProps = function getEmptyStateProps(defaultEmptyState) {
    var noSuggestions = filteredList.every(function (i) {
      return i.noFilter;
    });

    if (noSuggestions && emptyState && !creatable) {
      return typeof emptyState === "boolean" ? defaultEmptyState : (0,utils_dist_index_esm/* runIfFn */.Pu)(emptyState, {
        query: query
      });
    }
  };

  return {
    autoCompleteProps: autoCompleteProps,
    children: children,
    filteredList: filteredList,
    filteredResults: filteredResults,
    focusedValue: focusedValue,
    getEmptyStateProps: getEmptyStateProps,
    getGroupProps: getGroupProps,
    getInputProps: getInputProps,
    getItemProps: getItemProps,
    getListProps: getListProps,
    inputRef: inputRef,
    interactionRef: interactionRef,
    isOpen: isOpen,
    itemList: itemList,
    listRef: listRef,
    onClose: onClose,
    onOpen: onOpen,
    query: query,
    removeItem: removeItem,
    resetItems: resetItems,
    setQuery: setQuery,
    tags: tags,
    values: values
  };
}

var AutoComplete = /*#__PURE__*/(0,system_dist_index_esm/* forwardRef */.Gp)(function (props, ref) {
  var context = useAutoComplete(props);
  var children = context.children,
      isOpen = context.isOpen,
      onClose = context.onClose,
      onOpen = context.onOpen,
      resetItems = context.resetItems,
      removeItem = context.removeItem;
  (0,react.useImperativeHandle)(ref, function () {
    return {
      resetItems: resetItems,
      removeItem: removeItem
    };
  });
  return react.createElement(AutoCompleteProvider, {
    value: context
  }, react.createElement(popover_dist_index_esm/* Popover */.J2, {
    isLazy: true,
    isOpen: isOpen,
    onClose: onClose,
    onOpen: onOpen,
    autoFocus: false,
    placement: "bottom",
    closeOnBlur: true
  }, react.createElement(system_dist_index_esm/* chakra.div */.m$.div, {
    sx: {
      ".chakra-popover__popper": {
        position: "unset !important"
      }
    },
    w: "full",
    ref: ref
  }, children)));
});
AutoComplete.displayName = "AutoComplete";

var _excluded$1 = ["children", "dangerouslySetInnerHTML"];
var AutoCompleteItem = /*#__PURE__*/(0,system_dist_index_esm/* forwardRef */.Gp)(function (props, forwardedRef) {
  var _useAutoCompleteConte = useAutoCompleteContext(),
      focusedValue = _useAutoCompleteConte.focusedValue,
      getItemProps = _useAutoCompleteConte.getItemProps,
      interactionRef = _useAutoCompleteConte.interactionRef;

  var itemRef = (0,react.useRef)();
  var ref = (0,dist_index_esm/* useMergeRefs */.qq)(forwardedRef, itemRef);
  var itemProps = getItemProps(props);
  var _itemProps$root = itemProps.root,
      isValidSuggestion = _itemProps$root.isValidSuggestion,
      value = _itemProps$root.value;
  var isFocused = focusedValue === value;
  (0,react.useEffect)(function () {
    var _itemRef$current;

    if (isFocused && interactionRef.current === "keyboard") itemRef == null ? void 0 : (_itemRef$current = itemRef.current) == null ? void 0 : _itemRef$current.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  }, [isFocused, interactionRef]);
  (0,react.useEffect)(function () {
    if (typeof value !== "string") console.warn("wow");
    if (typeof value !== "string" && (0,utils_dist_index_esm/* isUndefined */.o8)(props.getValue)) console.error("You must define the `getValue` prop, when an Item's value is not a string");
  }, []);

  var _itemProps$item = itemProps.item,
      children = _itemProps$item.children,
      dangerouslySetInnerHTML = _itemProps$item.dangerouslySetInnerHTML,
      restProps = _objectWithoutPropertiesLoose(_itemProps$item, _excluded$1);

  var rest = (0,utils_dist_index_esm/* omit */.CE)(restProps, ["groupId"]);
  return isValidSuggestion ? react.createElement(layout_dist_index_esm/* Flex */.kC, Object.assign({
    ref: ref
  }, baseItemStyles, rest), children ? children : react.createElement("span", {
    dangerouslySetInnerHTML: dangerouslySetInnerHTML
  })) : null;
});
AutoCompleteItem.displayName = "AutoCompleteItem";
var baseItemStyles = {
  mx: "2",
  px: "2",
  py: "2",
  rounded: "md",
  cursor: "pointer"
};

var _excluded$2 = ["alwaysDisplay", "children"],
    _excluded2$1 = ["children"];
function AutoCompleteCreatable(props) {
  var alwaysDisplay = props.alwaysDisplay,
      childrenProp = props.children,
      rest = _objectWithoutPropertiesLoose(props, _excluded$2);

  var _useAutoCompleteConte = useAutoCompleteContext(),
      autoCompleteProps = _useAutoCompleteConte.autoCompleteProps,
      getItemProps = _useAutoCompleteConte.getItemProps,
      query = _useAutoCompleteConte.query,
      filteredResults = _useAutoCompleteConte.filteredResults;

  var _getItemProps$item = getItemProps(_extends({}, props, {
    value: query,
    children: (0,utils_dist_index_esm/* runIfFn */.Pu)(childrenProp, {
      value: query
    })
  }), true).item,
      children = _getItemProps$item.children,
      itemProps = _objectWithoutPropertiesLoose(_getItemProps$item, _excluded2$1);

  var queryExistsInList = filteredResults.some(function (i) {
    return i.value === query;
  });
  var showWhenEmpty = (0,utils_dist_index_esm/* isEmpty */.xb)(query) ? alwaysDisplay : true;
  var showCreatable = autoCompleteProps.creatable && showWhenEmpty && !queryExistsInList;
  return showCreatable ? react.createElement(layout_dist_index_esm/* Flex */.kC, Object.assign({}, baseItemStyles, itemProps, rest), children || "Add " + query) : null;
}
AutoCompleteCreatable.displayName = "AutoCompleteCreatable";

var _excluded$3 = ["children", "showDivider"];
var AutoCompleteGroup = /*#__PURE__*/(0,system_dist_index_esm/* forwardRef */.Gp)(function (props, ref) {
  var children = props.children,
      restProps = _objectWithoutPropertiesLoose(props, _excluded$3);

  var rest = (0,utils_dist_index_esm/* omit */.CE)(restProps, ["groupSibling"]);

  var _useAutoCompleteConte = useAutoCompleteContext(),
      getGroupProps = _useAutoCompleteConte.getGroupProps;

  var _getGroupProps = getGroupProps(props),
      group = _getGroupProps.group;

  var dividerStyles = useDividerStyles(props);
  return react.createElement(layout_dist_index_esm/* Box */.xu, Object.assign({
    ref: ref
  }, group, rest), react.createElement(layout_dist_index_esm/* Divider */.iz, Object.assign({}, dividerStyles.top)), children, react.createElement(layout_dist_index_esm/* Divider */.iz, Object.assign({}, dividerStyles.bottom)));
});
var AutoCompleteGroupTitle = /*#__PURE__*/(0,system_dist_index_esm/* forwardRef */.Gp)(function (props, ref) {
  return react.createElement(layout_dist_index_esm/* Flex */.kC, Object.assign({}, baseTitleStyles, props, {
    ref: ref
  }));
});
AutoCompleteGroup.displayName = "AutoCompleteGroup";
AutoCompleteGroupTitle.displayName = "AutoCompleteGroupTitle";
var baseTitleStyles = {
  ml: 5,
  my: 1,
  fontSize: "xs",
  letterSpacing: "wider",
  fontWeight: "extrabold",
  textTransform: "uppercase"
};

var useDividerStyles = function useDividerStyles(props) {
  var _useAutoCompleteConte2 = useAutoCompleteContext(),
      getGroupProps = _useAutoCompleteConte2.getGroupProps;

  var hasGroupSibling = props.groupSibling;

  var _getGroupProps2 = getGroupProps(props),
      _getGroupProps2$divid = _getGroupProps2.divider,
      hasFirstChild = _getGroupProps2$divid.hasFirstChild,
      hasLastChild = _getGroupProps2$divid.hasLastChild;

  var baseStyles = {
    my: 2,
    borderColor: props.dividerColor
  };

  var top = _extends({}, baseStyles, {
    mb: 4,
    display: !props.showDivider || hasFirstChild ? "none" : ""
  });

  var bottom = _extends({}, baseStyles, {
    display: !props.showDivider || hasLastChild || hasGroupSibling ? "none" : ""
  });

  return {
    top: top,
    bottom: bottom
  };
};

var _excluded$4 = ["children", "isInvalid"],
    _excluded2$2 = ["ref"];
var AutoCompleteInput = /*#__PURE__*/(0,system_dist_index_esm/* forwardRef */.Gp)(function (props, forwardedRef) {
  var _useAutoCompleteConte = useAutoCompleteContext(),
      autoCompleteProps = _useAutoCompleteConte.autoCompleteProps,
      inputRef = _useAutoCompleteConte.inputRef,
      getInputProps = _useAutoCompleteConte.getInputProps,
      tags = _useAutoCompleteConte.tags; // const ref = useMergeRefs(forwardedRef, inputRef);


  var childrenProp = props.children,
      isInvalid = props.isInvalid,
      rest = _objectWithoutPropertiesLoose(props, _excluded$4);

  var themeInput = (0,system_dist_index_esm/* useMultiStyleConfig */.jC)("Input", props);

  var _getInputProps = getInputProps(rest, themeInput),
      wrapper = _getInputProps.wrapper,
      inputProps = _getInputProps.input;

  var wrapperRef = wrapper.ref,
      wrapperProps = _objectWithoutPropertiesLoose(wrapper, _excluded2$2);

  var ref = (0,dist_index_esm/* useMergeRefs */.qq)(forwardedRef, inputRef);
  var children = (0,utils_dist_index_esm/* runIfFn */.Pu)(childrenProp, {
    tags: tags
  });
  var simpleInput = react.createElement(input_dist_index_esm/* Input */.II, Object.assign({
    isInvalid: isInvalid
  }, inputProps, {
    ref: ref
  }));
  var multipleInput = react.createElement(layout_dist_index_esm/* Wrap */.Eq, Object.assign({}, wrapperProps, {
    ref: wrapperRef
  }), children, react.createElement(layout_dist_index_esm/* WrapItem */.Uc, Object.assign({
    as: input_dist_index_esm/* Input */.II
  }, inputProps, {
    ref: ref
  })));
  return react.createElement(react.Fragment, null, autoCompleteProps.multiple ? multipleInput : simpleInput);
});
AutoCompleteInput.displayName = "Input";
AutoCompleteInput.id = "Input";

var EmptyState = function EmptyState(props) {
  var _useAutoCompleteConte = useAutoCompleteContext(),
      getEmptyStateProps = _useAutoCompleteConte.getEmptyStateProps;

  var emptyState = getEmptyStateProps(react.createElement(layout_dist_index_esm/* Flex */.kC, Object.assign({}, emptyStyles), "No options found!"));
  return react.createElement(layout_dist_index_esm/* Box */.xu, Object.assign({}, props), emptyState);
};
var emptyStyles = {
  fontSize: "sm",
  align: "center",
  justify: "center",
  fontWeight: "bold",
  fontStyle: "italic"
};

var VALID_AUTOCOMPLETE_LIST_CHILDREN = ["AutoCompleteGroup", "AutoCompleteItem", "AutoCompleteCreatable"];
var siblingInfo = function siblingInfo(children) {
  var items = react.Children.map(children, function (child, i) {
    var _child$type;

    if ((child == null ? void 0 : (_child$type = child.type) == null ? void 0 : _child$type.displayName) === "AutoCompleteGroup") {
      var sibling = react.Children.toArray(children)[i + 1];
      return react.cloneElement(child, {
        groupSibling: sibling ? sibling.type.displayName === "AutoCompleteGroup" : false
      });
    }

    return child;
  });
  var nonAutocompleteItems = react.Children.toArray(items).filter(function (child) {
    var _child$type2;

    return !VALID_AUTOCOMPLETE_LIST_CHILDREN.includes(child == null ? void 0 : (_child$type2 = child.type) == null ? void 0 : _child$type2.displayName);
  });
  var autoCompleteItems = react.Children.toArray(items).filter(function (child) {
    var _child$type3;

    return VALID_AUTOCOMPLETE_LIST_CHILDREN.includes(child == null ? void 0 : (_child$type3 = child.type) == null ? void 0 : _child$type3.displayName);
  });
  return [autoCompleteItems, nonAutocompleteItems];
};

var _excluded$5 = ["children"];
var AutoCompleteList = /*#__PURE__*/(0,system_dist_index_esm/* forwardRef */.Gp)(function (props, forwardedRef) {
  var children = props.children,
      rest = _objectWithoutPropertiesLoose(props, _excluded$5);

  var _useAutoCompleteConte = useAutoCompleteContext(),
      listRef = _useAutoCompleteConte.listRef,
      getListProps = _useAutoCompleteConte.getListProps;

  var ref = (0,dist_index_esm/* useMergeRefs */.qq)(forwardedRef, listRef);
  var listProps = getListProps();

  var _siblingInfo = siblingInfo(children),
      autoCompleteItems = _siblingInfo[0],
      nonAutoCompleteItems = _siblingInfo[1];

  return react.createElement(popover_dist_index_esm/* PopoverContent */.yk, Object.assign({
    ref: ref
  }, baseStyles, listProps, rest), autoCompleteItems, react.createElement(EmptyState, null), nonAutoCompleteItems);
});
AutoCompleteList.displayName = "AutoCompleteList";
var baseStyles = {
  mt: "4",
  py: "4",
  opacity: "0",
  bg: "#232934",
  rounded: "md",
  maxH: "350px",
  border: "none",
  shadow: "base",
  pos: "absolute",
  zIndex: "popover",
  overflowY: "auto",
  _light: {
    bg: "#ffffff"
  },
  _focus: {
    boxShadow: "none"
  }
};

var _excluded$6 = (/* unused pure expression or super */ null && (["label", "onRemove", "disabled"]));
var AutoCompleteTag = /*#__PURE__*/(/* unused pure expression or super */ null && (memo(function (props) {
  var label = props.label,
      onRemove = props.onRemove,
      disabled = props.disabled,
      rest = _objectWithoutPropertiesLoose(props, _excluded$6);

  return React.createElement(WrapItem$1, null, React.createElement(Tag, Object.assign({
    borderRadius: "md",
    fontWeight: "normal"
  }, disabled && disabledStyles, rest), React.createElement(TagLabel, null, label), React.createElement(TagCloseButton, Object.assign({
    onClick: function onClick() {
      return !disabled && runIfFn(onRemove);
    },
    cursor: "pointer"
  }, disabled && disabledStyles))));
})));
var disabledStyles = {
  cursor: "text",
  userSelect: "none",
  opacity: 0.4,
  _focus: {
    boxShadow: "none"
  }
};


//# sourceMappingURL=chakra-autocomplete.esm.js.map


/***/ })

}]);